import { render } from "./TemplateEditView.vue?vue&type=template&id=c5bb7d94&scoped=true"
import script from "./TemplateEditView.vue?vue&type=script&lang=js"
export * from "./TemplateEditView.vue?vue&type=script&lang=js"

import "./TemplateEditView.vue?vue&type=style&index=0&id=c5bb7d94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5bb7d94"]])

export default __exports__